import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ODataParams, ODataResponse } from '@tdw/core';
import { map, Observable } from 'rxjs';
import { EnvironmentConfig, ENV_CONFIG } from 'src/environments/environment.model';
import { DrawingMapping, FlatterFilesResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class DrawingMappingService {

  constructor(private http: HttpClient, @Inject(ENV_CONFIG) private config: EnvironmentConfig) { }

  get(q: ODataParams): Observable<ODataResponse<DrawingMapping[]>> {
    const endpoint = this.config.endpoints?.baseApi;
    return this.http.get<ODataResponse<DrawingMapping[]>>(`${endpoint?.url}odata/${endpoint?.version}/Drawings${q.toQuery()}`);
  }

  patch(id: string, obj: Partial<DrawingMapping>): Observable<any> {
    const endpoint = this.config.endpoints?.baseApi;
    return this.http.patch(`${endpoint?.url}odata/${endpoint?.version}/Drawings?id=${id}`, obj);
  }

  post(obj: DrawingMapping): Observable<any> {
    const endpoint = this.config.endpoints?.baseApi;
    return this.http.post(`${endpoint?.url}odata/${endpoint?.version}/Drawings`, obj);
  }

  getExistenceGraph(fileNames: string[]): Observable<{ [key: string]: FlatterFilesResponse }> {
    const endpoint = this.config.endpoints?.baseApi;
    return this.http.get<{ [key: string]: FlatterFilesResponse }>(`${endpoint?.url}api/${endpoint?.version}/Drawings/flatterfiles/forFilenames?filenames=${fileNames}`);
  }
}
